import React from 'react';
import { COMPARE_PRICE, LAUNCH_ACTIVE, NEXT_PRICE, PRICE, SAVINGS } from '../data/config';
import { offerChecklist, purchaseAssurances } from '../data/kit';
import { CTAButton, Section, Tag } from './Shared';
import { Bat } from './HalloweenDecor';
export function MainOffer() {
  return <Section id="oferta" tone="white" data-id="element-146" data-mp="1ltv7c72ym2ub">
      <article className="mx-auto max-w-5xl overflow-hidden rounded-3xl border-[3px] border-brand-violet bg-white shadow-soft" data-id="element-147" data-mp="1lstz0adbvuga">
        <div className="h-2 bg-brand-orange" aria-hidden="true" data-id="element-148" data-mp="p1rpff655d42" />
        <div className="grid md:grid-cols-[1.1fr_0.9fr]" data-id="element-149" data-mp="u3qrmlq5a3zf">
          <div className="p-6 sm:p-8 md:p-10" data-id="element-150" data-mp="y4stzbfcyw5m">
            <Tag variant="orange" data-id="element-151" data-mp="y2zlrrp3k3vi">🎃 KIT COMPLETO</Tag>
            <h2 className="mt-4 text-[30px] font-extrabold leading-[1.1] text-brand-violet md:text-[40px]" data-id="element-152" data-mp="12v0w382pfkiw">
              TU KIT DISFRACES DE HALLOWEEN
            </h2>
            <p className="mt-2 text-lg font-bold text-brand-orangeDark md:text-xl" data-id="element-153" data-mp="6ba6g2b41vvw">2 tomos + 5 bonus de regalo</p>
            <p className="mt-3 text-base leading-relaxed text-brand-ink/85" data-id="element-154" data-mp="3qo238wax67n8">
              16 propuestas de disfraces y recursos para decorar, jugar y preparar los detalles de la celebración.
            </p>
            <ul className="mt-6 space-y-3" data-id="element-155" data-mp="3gxz0w5hwrhc8">
              {offerChecklist.map(item => <li key={item} className="flex items-start gap-3 text-base text-brand-ink" data-id="element-156" data-mp="3gw5saknqin1l">
                  <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-orange text-sm font-bold text-brand-violet" data-id="element-157" data-mp="3bx1l1zkdezdw">
                    ✓
                  </span>
                  <span data-id="element-158" data-mp="2xzd24x9v62bh">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center border-t-2 border-dashed border-brand-violet/15 bg-brand-cream p-6 text-center sm:p-8 md:border-l-2 md:border-t-0 md:p-10" data-id="element-159" data-mp="2y17jy2pu9ebc">
            <p className="text-sm font-medium text-brand-ink/70" data-id="element-160" data-mp="w5nh80lp7u50">Precio de comparación</p>
            <p className="text-xl font-bold text-brand-ink/60 line-through" data-id="element-161" data-mp="r6u2k4uodx39">{COMPARE_PRICE}</p>
            <p className="mt-4 text-base font-bold text-brand-violet" data-id="element-162" data-mp="2lnu4rtjszdms">
              {LAUNCH_ACTIVE ? 'Precio de lanzamiento: llevate el kit por' : 'Llevate el kit por'}
            </p>
            <p className="font-display text-[56px] font-extrabold leading-none text-brand-violet md:text-[68px]" data-id="element-163" data-mp="2bsipna4hg4ei">
              {PRICE}
              <span className="ml-1 text-2xl md:text-3xl" data-id="element-164" data-mp="34fmwzlr1sutg">ARS</span>
            </p>
            <Tag variant="orange" className="mt-4" data-id="element-165" data-mp="34djva4gj9d8w">
              Ahorrás {SAVINGS}
            </Tag>
            {LAUNCH_ACTIVE && <p className="mt-3 text-sm font-bold text-brand-violet" data-id="element-166" data-mp="2uhypdv8cfstv">
                ⏰ Solo hasta el domingo 25/10 · Después aumenta a {NEXT_PRICE}
              </p>}
            <CTAButton width="full" className="mt-7" data-id="element-167" data-mp="1j2a4d9enh3vp">
              🎃 QUIERO MI KIT
              <Bat className="w-8 shrink-0" data-id="element-168" data-mp="1j4muwayh4mkd" />
            </CTAButton>
            <p className="mt-3 text-sm font-medium text-brand-ink/75" data-id="element-169" data-mp="1o2y4qlorqx2l">Pago único · Producto 100% digital</p>
            <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-170" data-mp="61x48uaq59pf">
              {purchaseAssurances.map(item => <li key={item} className="rounded-full bg-white px-3 py-1.5 text-sm font-bold text-brand-violet shadow-card" data-id="element-171" data-mp="14f5txuc2cvo">
                  {item}
                </li>)}
            </ul>
            <p className="mt-5 rounded-xl bg-brand-mint px-4 py-3 text-sm font-medium leading-snug text-brand-violet" data-id="element-172" data-mp="b3co4j161a68">
              Los materiales para realizar los proyectos se consiguen por separado.
            </p>
          </div>
        </div>
      </article>
    </Section>;
}